import createDuck from '../../../lib/ducks/remoteDuck'
import HomefeedApiHandler from '../../../lib/api/homefeed'

export default createDuck({
  namespace: 'content',
  store: 'homefeed',
  fetchCallback: (option) => HomefeedApiHandler.getHomefeed(option),
})
